import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
      // meta: { title: '体模质检' },
    },
    {
      path: '/privacy',
      name: 'Privacy',
      // 使用 iframe 来嵌入静态 HTML
      component: {
        template: '<iframe src="/static/privacy.html" width="100%" height="100%" frameborder="0"></iframe>'
      }
    },
    {
      path: '/user_agreement',
      name: 'UserAgreement',
      // 使用 iframe 来嵌入静态 HTML
      component: {
        template: '<iframe src="/static/user_agreement.html" width="100%" height="100%" frameborder="0"></iframe>'
      }
    },
    {
      path: '/mechanical',
      name: 'Mechanical',
      component: () => import('@/components/evaluating/Mechanical')
      // meta: { title: '骨骼肌力学定量评测'},
    },
    {
      path: '/mechanicalResult',
      name: 'MechanicalResult',
      component: () => import('@/components/evaluating/MechanicalResult')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js